const messages = {
  title: "Bridgestone <span class='text-danger'>PLUS</span> Shop",
  description:
    "Welkom in de Bridgestone PLUS Shop. Hier kunt u uw Bridgestone Plus-punten <br/> inwisselen voor beloningen uit verschillende categorieën. Het productassortiment <br/>wordt regelmatig bijgewerkt.",
  sort: {
    asc: "Sorteren op laagste prijs",
    desc: "Sorteren op hoogste prijs",
  },
  productSearchBox: {
    from: "Punten vanaf",
    to: "Punten tot",
  },
  noProducts: "De zoekcriteria leverden geen resultaten op",
  quantity: "Aantal",
  search: "Zoeken",
  perPage: "Items per pagina",
  timeUnavailable: "Momenteel niet beschikbaar.",
  product: "Product",
  cart: {
    pointsPerUnit: "Punten per stuk",
    pointsSum: "Totaal aantal punten",
  },
  action: "Actie",
  pointsTotal: "Totaal",
  cartRemainPoints: "punten resterend",
  shoppingCart: "Winkelwagen",
  emptyCart: "Winkelwagen is leeg.",
  attributes: "Kenmerken",
  selectAddressP: "Selecteer uw leveradres",
  orderDelivery: "Leveringsadres",
  selectedProducts: "Geselecteerde producten",
  orderSummary: "Bestellingsoverzicht",
  contactPerson: "Contactpersoon",
  selectedAddress: "Geselecteerd adres",
  order: {
    success:
      "Bedankt! Uw bestelling is gelukt. U ontvangt binnen enkele minuten een orderbevestiging in uw inbox.",
    description: "Raadpleeg de geschiedenis van uw puntenbestellingen.",
    info: "Hier vindt u een overzicht van uw bestellingen in de Bridgestone <span class='text-danger'>PLUS</span> Shop.",
    date: "Besteldatum",
    number: "Bestelnr.",
    status: {
      created: "Gemaakt",
      confirm_order: "Bestelling bevestigen",
      ready_for_shipment: "Klaar voor verzending",
      rejected: "Afgewezen",
      processed: "Verwerkt",
      shipped: "Verzonden",
      returned: "Teruggestuurd",
      finished: "Klaar",
    },
    anyOrder: "Geen bestellingen",
    products: "Producten",
    quantity_short: "stuks",
    itemRemoved: "niet leverbaar",
  },
  orders: "Bestellingen Bridgestone <span class='text-danger'>PLUS</span> shop",
  notEnoughPoints: "Er zijn niet genoeg punten beschikbaar.",
  statusText: "Status",
  outOfStock: "Momenteel niet op voorraad",
  productUnavailable: "Dit product is niet meer beschikbaar.",
  deletedProductsTitle: "Producten niet meer beschikbaar",
  deletedProductsMessage:
    "De volgende producten zijn niet meer beschikbaar. Verwijder ze uit je winkelmand om verder te gaan.",
  removeSelected: "Selectie verwijderen",
  clearCart: "Winkelmand legen",
  removeSelectedConfirm:
    "De geselecteerde producten uit je winkelmand verwijderen?",
  clearCartConfirm: "Alle producten uit je winkelmand verwijderen?",
  incompleteAddress: {
    firstName: "Voeg een voornaam toe aan het afleveradres",
    lastName: "Voeg een achternaam toe aan het afleveradres",
    company: "Voeg een bedrijfsnaam toe aan het afleveradres",
    street: "Voeg een straat en huisnummer toe aan het afleveradres",
    postalCode: "Voeg een postcode toe aan het afleveradres",
    city: "Voeg een plaats toe aan het afleveradres",
    country: "Voeg een land toe aan het afleveradres",
    phone: "Voeg een telefoonnummer toe aan het afleveradres",
  },
  variant: "Varianten selecteerbaar",
  placeOrder: "BEVESTIG UW BESTELLING",
  toOrderDelivery: "Ga verder naar het afleveradres",
  toOrderSummary: "Verder naar bestellen",
  productImg: "Product afbeelding",
  selectAddressBtn: "Kies adres",
  perPgae: "Items per pagina",
  categories: {
    advertising: {
      title: "Reclamemateriaal",
      desc: "Neem direct deel hier op het platform en verzamel <br /> 40 extra punten voor de beloningsclub.",
    },
    rewards: {
      title: "Exclusieve beloningen",
      desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
    },
    tools: {
      title: "Werkplaats gereedschap",
      desc: "Gebruik uw punten voor <br /> trainingen van derden en verlaag uw kosten.",
    },
    trainings: {
      title: "Training & onderwijs",
      desc: "Ontdek het bonusaanbod in ons trainingscentrum of bij u op locatie.",
    },
    salesroom: {
      title: "Verkoopruimte",
      desc: "Richt de verkoopruimte in en bied uw klanten een aangenaam verblijf.",
    },
    hunter: {
      title: "Hunter",
      desc: "Inruilpunten voor aantrekkelijke werkplaatsinrichting van Hunter.",
    },
  },
  bestSold: "Meest verkocht",
  seasonal: "Seizoensgebonden",
  affordable: "Ontdek",
  forPoints: "{points} punten",
  reachedPoints: "Voldoende punten beschikbaar",
  remainingPoints: "Nog {points} punten nodig",
  favoriteProducts: {
    description: "Hier vindt u de producten die u heeft opgeslagen.",
  },
  categoryPageDescriptionFallback:
    "Materiaal voor in de werkplaats of andere kwalitatieve producten met het Bridgestone-logo voor uw bedrijf",
};
export default {
  messages,
};
